import { Injectable } from '@angular/core';
import { hostConfig } from '../common.model';

@Injectable({
  providedIn: 'root',
})
export class DictionaryAPIService {
  static addPrefix(url: string, prefix = hostConfig.loginApi, isBulkDomain: boolean = false) {
    if (isBulkDomain) {
      const splitter: string = '://';
      const urlParts: string[] = prefix.split(splitter);

      if (urlParts.length === 2) {
        const [protocol, domain] = urlParts;
        const rootDomain = hostConfig.bulkDomain?.endsWith('.') ? hostConfig.bulkDomain : hostConfig.bulkDomain + '.';

        return [protocol, splitter, rootDomain, domain, url].join('');
      }

      console.warn('could not parse prefix', prefix);
    }

    return prefix + url;
  }

  getPortals = (): string => DictionaryAPIService.addPrefix('/api/login/noauth/clients/searchByEmail');
  login = (): string => DictionaryAPIService.addPrefix('/api/login/noauth/login');
  getClientSSO = (clientName: string): string =>
    DictionaryAPIService.addPrefix(`/api/login/noauth/clients/search?clientAlias=${clientName}`);
  getSSORelayState = (): string => DictionaryAPIService.addPrefix(`/api/login/noauth/relaystate`);
  getSSOData = (userId: string) => DictionaryAPIService.addPrefix(`/sso-data/${userId}`);

  systemLanguages = (): string => DictionaryAPIService.addPrefix('/noauth/api/languages', hostConfig.monolithApi);
  clientLanguages = (clientId: string): string =>
    DictionaryAPIService.addPrefix(`/noauth/api/languages?clientId=${clientId}`, hostConfig.monolithApi);
  systemLabels = (): string => DictionaryAPIService.addPrefix(`/noauth/api/labels/bykeys`, hostConfig.monolithApi);

  updatelanguage = (): string => DictionaryAPIService.addPrefix(`/api/login/users/preferences`);
  getTermsAndConditions = (clientId: string, userId: string) =>
    DictionaryAPIService.addPrefix(`/api/login/clients/${clientId}/termsAndConditions/user/${userId}`);
  downloadTermsAndConditions = (clientId: string, termsAndConditionsId: string, modifiedDate: string) =>
    DictionaryAPIService.addPrefix(
      `/clients/${clientId}/terms-and-conditions/${termsAndConditionsId}/modified-date/${modifiedDate}`,
      hostConfig.reportServiceApi
    );
  acceptTermsAndConditions = (clientId: string, termsAndConditionsId: string, version: number) =>
    DictionaryAPIService.addPrefix(
      `/api/login/clients/${clientId}/termsAndConditions/${termsAndConditionsId}/version/${version}/accept`
    );

  /** Cross-Site Request Forgery */
  csrfToken = () => DictionaryAPIService.addPrefix('/api/login/security/csrf-token');

  /** Customization */
  customization = (clientId: string): string =>
    DictionaryAPIService.addPrefix(`/noauth/api/clients/${clientId}/customization`, hostConfig.monolithApi);

  customizationColorScheme = (clientId: string): string =>
    DictionaryAPIService.addPrefix(
      `/noauth/api/clients/${clientId}/customization/color-scheme`,
      hostConfig.monolithApi
    );
  fileDownload = (fileId: string): string => DictionaryAPIService.addPrefix(`/${fileId}`, hostConfig.fileServiceApi);
  /** Localization */
  localization = (clientId: string): string =>
    DictionaryAPIService.addPrefix(`/noauth/api/clients/${clientId}/localization`, hostConfig.monolithApi);

  /** Logout */
  logoutUserFromTerms = (clientId: string): string =>
    DictionaryAPIService.addPrefix(`/api/login/clients/${clientId}/termsAndConditions/cancel`);
}
